import { render } from "./BusinessCoachingEng.vue?vue&type=template&id=96aacc00&scoped=true&lang=html"
import script from "./BusinessCoachingEng.vue?vue&type=script&lang=js"
export * from "./BusinessCoachingEng.vue?vue&type=script&lang=js"

import "./BusinessCoachingEng.vue?vue&type=style&index=0&id=96aacc00&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-96aacc00"

export default script